"use client";

import { TrendingUp } from "lucide-react";
import { CartesianGrid, Label, Line, LineChart, XAxis, YAxis } from "recharts";
import { ChartContainer, ChartTooltip, ChartTooltipContent } from "../ui/chart";
import { isA23 } from "@/src/routes/Stats/Stats";

export const description = "A line chart";

const chartConfig = {};

export function CurvedLineCharts({ chartCls, chartDataConfig, chartData }) {
  return (
    <ChartContainer
      className={`w-full aspect-square ${chartCls}`}
      config={chartConfig}
    >
      <LineChart
        accessibilityLayer
        data={chartData}
        margin={{
          left: 5,
          right: 12,
          bottom: 12,
          top: 12,
        }}
      >
        {/* <CartesianGrid /> */}
        <YAxis
          dataKey={chartDataConfig.yAxisKey}
          axisLine={true}
          stroke="var(--color-secondary)"
          tickMargin={5}
          tickLine={false}
        >
          <Label
            fill="var(--color-secondary)"
            className="text-[10px]"
            value={chartDataConfig.yAxisLabel}
            offset={10}
            position="insideBottomLeft"
            angle={-90}
          />
        </YAxis>
        <XAxis
          dataKey={chartDataConfig.xAxisKey}
          tickLine={false}
          axisLine={true}
          tickMargin={5}
          stroke="var(--color-secondary)"
        >
          <Label
            fill="var(--color-secondary)"
            className="text-[10px]"
            value={chartDataConfig.xAxisLabel}
            offset={isA23 ? -10 : 0}
            position={isA23 ? "insideBottomRight" : "bottom"}
          />
        </XAxis>
        <ChartTooltip
          cursor={false}
          content={<ChartTooltipContent hideLabel />}
        />
        <Line
          dataKey={chartDataConfig.yAxisKey}
          type="natural"
          stroke="var(--green-400)"
          strokeWidth={3}
          dot={false}
        />
      </LineChart>
    </ChartContainer>
  );
}
